import { UntypedFormBuilder, FormGroup } from '@angular/forms';
export interface GenerateOptions {
  entity: any;
  options: any;
  formBuilder: UntypedFormBuilder;
  generateForm: (entity: any, options?: any) => FormGroup;
  ownerId?: any;
  propertyName?: 'owners' | 'products' | 'parameters';
}
export default {
  generate: (generalOptions: GenerateOptions) => {
    const {
      entity,
      options,
      formBuilder,
      generateForm,
      ownerId = null,
      propertyName = 'owners',
    } = generalOptions || {};

    const formArray = generateFormArray(
      entity,
      generateForm,
      options,
      ownerId,
      propertyName,
    );
    return formBuilder.group(
      {
        [propertyName]: formBuilder.array(formArray || [], options),
      },
      options,
    );
  },
};
function generateFormArray(
  entity: any,
  generateForm: (entity, options?) => FormGroup,
  options: any,
  ownerId: any,
  propertyName: 'owners' | 'products' | 'parameters',
): FormGroup[] {
  let formArray: FormGroup[] = [];
  const items = entity?.[propertyName];
  if (ownerId && items?.length) {
    const item = findItemByIdOrMain(items, ownerId) || items[0];

    if (item) {
      formArray.push(generateForm(item, options || {}));
    } else {
      const defaultItem = entity[0] ? entity[0] : entity;
      formArray.push(generateForm(defaultItem, options || {}));
    }
  } else if (entity && items?.length) {
    items?.forEach(item => {
      formArray.push(generateForm(item, options || {}));
    });
  }

  return formArray;
}
function findItemByIdOrMain(items: any[], ownerId: any) {
  return items.find(
    item => item?.isMain || (item?.ownerId || item?.productId) === ownerId,
  );
}
